import { render } from "./projectsReportPage.vue?vue&type=template&id=37d3b6b2"
import script from "./projectsReportPage.vue?vue&type=script&lang=js"
export * from "./projectsReportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__